import { IProviderContext } from "smarthub-common";
import { IProps } from "../props";
import { cogSvc } from "./cogSvc";
import { appAuth } from "./appAuth";
import { panels } from "./panels";
import { preferences } from "./preferences";

export const providers = (props: IProps): IProviderContext => ({
  cogsvc: [cogSvc(props)],
  auth: [appAuth(props)],
  panels: panels(props),
  preferences: preferences(props),
});
